'use strict';

function parse(reader) {
    reader.readUInt8('data.params.rule_index');
    reader.readString(reader.getLength() - 7, 'data.params.text');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/message-condition-parser.js